import { render, staticRenderFns } from "./ExternalPosMappingAnomalies.vue?vue&type=template&id=162b05b0&scoped=true"
import script from "./ExternalPosMappingAnomalies.vue?vue&type=script&lang=js"
export * from "./ExternalPosMappingAnomalies.vue?vue&type=script&lang=js"
import style0 from "./ExternalPosMappingAnomalies.vue?vue&type=style&index=0&id=162b05b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b05b0",
  null
  
)

export default component.exports